import Vue from 'vue'
import Router from 'vue-router'
// pc端
import home from '@/components/pc_viwe/home' //首页
// import edit_home from '@/components/pc_viwe/edit_home'//首页修改
import column from '@/components/pc_viwe/column' //栏目  
import contentFile from '@/components/pc_viwe/contentFile' //内容文件  
import column_details from '@/components/pc_viwe/column_details' //栏目详情
import content_details from '@/components/pc_viwe/content_details' //栏目详情
import found from '@/components/pc_viwe/found' //发现
import personal from '@/components/pc_viwe/personal' //个人中心
import my_focus from '@/components/pc_viwe/my_focus' //个人关注
import my_collection from '@/components/pc_viwe/my_collection' //个人收藏
import my_comments from '@/components/pc_viwe/my_comments' //个人评论
import my_rules from '@/components/pc_viwe/my_rules' //规则
import my_personal from '@/components/pc_viwe/my_personal' //个人资料
import my_setUp from '@/components/pc_viwe/my_setUp' //设置
import message from '@/components/pc_viwe/message' //消息
import index from '@/components/pc_viwe/index' //直播首页
import pc_record from '@/components/pcVideo/pc_record' //录播
import pc_move from '@/components/pcVideo/pc_move' //直播
import pc_activity from '@/components/pcActivity/pc_activity' //活动
import activitiesList from '@/components/pcActivity/activitiesList' //活动列表
import activitiesDetails from '@/components/pcActivity/activitiesDetails' //活动详情
import activitiesForm from '@/components/pcActivity/activitiesForm' //活动表单



// 移动端
import m_login from '@/components/minLogin/m_login'
import m_password from '@/components/minLogin/m_password'
import m_code from '@/components/minLogin/m_code'
import m_forget from '@/components/minLogin/m_forget'
import m_registered from '@/components/minLogin/m_registered'
import m_information from '@/components/minLogin/m_information'
import m_binding from '@/components/minLogin/m_binding'

import m_guide from '@/components/min_view/m_guide'
import m_found from '@/components/min_view/m_found'
import m_home from '@/components/min_view/m_home'
import m_column from '@/components/min_view/m_column'
import m_content_file from '@/components/min_view/m_content_file'
import m_new_search from '@/components/min_view/m_new_search'
import m_my from '@/components/min_view/m_my'
import m_personal from '@/components/min_view/m_personal'
import m_integral from '@/components/min_view/m_integral'
import m_rules from '@/components/min_view/m_rules'
import m_setUp from '@/components/min_view/m_setUp'
import m_focus from '@/components/min_view/m_focus'
import m_collection from '@/components/min_view/m_collection'
import m_comments from '@/components/min_view/m_comments'
import m_column_details from '@/components/min_view/m_column_details'
import m_content_details from '@/components/min_view/m_content_details'
import m_column_comments from '@/components/min_view/m_column_comments'
import m_message from '@/components/min_view/m_message'
import m_message_details from '@/components/min_view/m_message_details'
import m_activity from '@/components/minActivity/m_activity.vue' //活动
import m_activityform from '@/components/minActivity/m_activityForm.vue' //活动表单
import m_activitylist from '@/components/minActivity/m_activityList.vue' //活动列表
import m_activityDetails from '@/components/minActivity/m_activityDetails.vue' //活动详情

import m_index from '@/components/min_view/m_index'
import min_record from '@/components/minVideo/min_record'
import min_move from '@/components/minVideo/min_move'

import privacy from '@/components/tool/privacy'
import user_agreement from '@/components/tool/user_agreement'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    // mode:'history',//消除#号
    routes: [
        // pc端
        {
            path: '/',
            name: 'home',
            component: home
        },
        // //首页修改
        // {
        //   path: '/edit_home',
        //   name: 'edit_home',
        //   component: edit_home
        // },
        {
            path: '/column',
            name: 'column',
            component: column
        },
        {
            path: '/contentFile',
            name: 'contentFile',
            component: contentFile
        },
        {
            path: '/vedio',
            name: 'vedioIndex',
            component: () =>
                import('@/components/pc_viwe/vedio/index.vue'),
        },
        {
            path: '/vedio_list',
            name: 'vedioList',
            component: () =>
                import('@/components/pc_viwe/vedio/vedio_list.vue'),
        },
        {
            path: '/vedio_detil',
            name: 'vedioDetil',
            component: () =>
                import('@/components/pc_viwe/vedio/vedio_detil.vue'),
        },
        {
            path: '/search_info',
            name: 'searchInfo',
            component: () =>
                import('@/components/pc_viwe/search_info.vue'),
        },
        {
            path: '/meet_index',
            name: 'meetIndex',
            component: () =>
                import('@/components/pc_viwe/meeting/index.vue'),
        },
        {
            path: '/ceshi',
            name: 'ceshi',
            component: () =>
                import('@/components/pc_viwe/ceshi.vue'),
        },
        {
            path: '/column_details',
            name: 'column_details',
            component: column_details
        },
        {
            path: '/content_details',
            name: 'content_details',
            component: content_details
        },
        {
            path: '/found',
            name: 'found',
            component: found
        },
        {
            path: '/personal',
            name: 'personal',
            component: personal,
            children: [
                {
                    path: '/',
                    name: 'my_focus',
                    component: my_focus
                },
                {
                    path: '/my_focus',
                    name: 'my_focus',
                    component: my_focus
                },
                {
                    path: '/my_collection',
                    name: 'my_collection',
                    component: my_collection
                },
                {
                    path: '/my_comments',
                    name: 'my_comments',
                    component: my_comments
                },
                {
                    path: '/my_rules',
                    name: 'my_rules',
                    component: my_rules
                },
                {
                    path: '/my_personal',
                    name: 'my_personal',
                    component: my_personal,
                },
                {
                    path: '/my_setUp',
                    name: 'my_setUp',
                    component: my_setUp,
                }
            ]
        },
        {
            path: '/message',
            name: 'message',
            component: message
        },
        {
            path: '/index',
            name: 'index',
            component: index
        },
        {
            path: '/pc_record',
            name: 'pc_record',
            component: pc_record
        },
        {
            path: '/pc_move',
            name: 'pc_move',
            component: pc_move
        },
        // 活动
        {
            path: '/pc_activity',
            name: 'pc_activity',
            component: pc_activity
        },
        {
            path: '/activitiesList',
            name: 'activitiesList',
            component: activitiesList
        },
        {
            path: '/activitiesDetails',
            name: 'activitiesDetails',
            component: activitiesDetails
        },
        {
            path: '/activitiesForm',
            name: 'activitiesForm',
            component: activitiesForm
        },




        //移动端
        {
            path: '/m_guide',
            name: 'm_guide',
            component: m_guide
        },
        {
            path: '/m_login',
            name: 'm_login',
            component: m_login
        },
        {
            path: '/m_password',
            name: 'm_password',
            component: m_password
        },
        {
            path: '/m_forget',
            name: 'm_forget',
            component: m_forget
        },
        {
            path: '/m_registered',
            name: 'm_registered',
            component: m_registered
        },
        // 视频
        {
            path: '/m_vedio_index',
            name: 'mvedioIndex',
            component: () =>
                import('@/components/min_view/m_vedio_index.vue'),
        },
        {
            path: '/m_vedio_dteil',
            name: 'mvediodteil',
            component: () =>
                import('@/components/min_view/m_vedio_dteil.vue'),
        },

        {
            path: '/m_information',
            name: 'm_information',
            component: m_information
        },
        {
            path: '/m_code',
            name: 'm_code',
            component: m_code
        },
        {
            path: '/m_binding',
            name: 'm_binding',
            component: m_binding
        },

        {
            path: '/m_found',
            name: 'm_found',
            component: m_found
        },
        {
            path: '/m_home',
            name: 'm_home',
            component: m_home
        },
        {
            path: '/m_column',
            name: 'm_column',
            component: m_column
        },
        {
            path: '/m_content_file',
            name: 'm_content_file',
            component: m_content_file
        },
        {
            path: '/m_my',
            name: 'm_my',
            component: m_my
        },
        {
            path: '/m_personal',
            name: 'm_personal',
            component: m_personal
        },
        {
            path: '/m_integral',
            name: 'm_integral',
            component: m_integral
        },
        {
            path: '/m_rules',
            name: 'm_rules',
            component: m_rules
        },
        {
            path: '/m_setUp',
            name: 'm_setUp',
            component: m_setUp
        },
        {
            path: '/m_focus',
            name: 'm_focus',
            component: m_focus
        },
        {
            path: '/m_collection',
            name: 'm_collection',
            component: m_collection
        },
        {
            path: '/m_comments',
            name: 'm_comments',
            component: m_comments
        },
        {
            path: '/m_column_details',
            name: 'm_column_details',
            component: m_column_details
        },
        {
            path: '/m_content_details',
            name: 'm_content_details',
            component: m_content_details
        },
        {
            path: '/m_column_comments',
            name: 'm_column_comments',
            component: m_column_comments
        },
        {
            path: '/m_message',
            name: 'm_message',
            component: m_message
        },
        {
            path: '/m_message_details',
            name: 'm_message_details',
            component: m_message_details
        },

        {
            path: '/m_index',
            name: 'm_index',
            component: m_index
        },
        {
            path: '/min_record',
            name: 'min_record',
            component: min_record
        },
        {
            path: '/min_move',
            name: 'min_move',
            component: min_move
        },
        {
            path: '/m_new_search',
            name: 'm_new_search',
            component: m_new_search
        },

        // 活动
        {
            path: '/m_activity',
            name: 'm_activity',
            component: m_activity
        },
        {
            path: '/m_activityform',
            name: 'm_activityform',
            component: m_activityform
        },
        {
            path: '/m_activitylist',
            name: 'm_activitylist',
            component: m_activitylist
        },
        {
            path: '/m_activityDetails',
            name: 'm_activityDetails',
            component: m_activityDetails
        },



        // 工具页面
        {
            path: '/privacy',
            name: 'privacy',
            component: privacy
        },
        {
            path: '/user_agreement',
            name: 'user_agreement',
            component: user_agreement
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js